import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import { programsStore } from '../../../ProgramsStore';
import { expiredProgramResource, visibleProgramResource } from '../../../ProgramsStore/Functions';
import ProgramDashboards from '../ProgramDashboard/ProgramDashboards';
import NoProgramsInTab from '../ProgramTabs/NoProgramsInTab';
import * as style from '../style.module.css';

const ExpiredPrograms: React.FC<{}> = () => {
  return (
    <div className={style.active} data-test-expired-programs={true}>
      {programsStore.resource
        .map(({ payload }) =>
          payload.programs.filter(expiredProgramResource).filter(visibleProgramResource),
        )
        .andThen(fromArrayMaybe)
        .map((expiredPrograms) => <ProgramDashboards programs={expiredPrograms} />)
        .getOrElse(() => (
          <NoProgramsInTab kind="You have no past programs" />
        ))}
    </div>
  );
};

export default observer(ExpiredPrograms);
